// src/internal/components/help-center-panel/functions/mimetypesConverter.ts
function mimeTypeConverter(fileType) {
  switch (fileType.trim()) {
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "mp4":
      return "video/mp4";
    case "webm":
      return "video/webm";
    case "ogg":
      return "audio/ogg";
    case "pdf":
      return "application/pdf";
    case "xml":
      return "application/xml";
    case "csv":
      return "text/csv";
    case "txt":
      return "text/plain";
    default:
      return "";
  }
}
function getMimeType(fileTypes) {
  if (!fileTypes)
    return void 0;
  return fileTypes.split(",").filter((mime) => !!mime).map((mime) => mimeTypeConverter(mime)).join(", ");
}

export {
  mimeTypeConverter,
  getMimeType
};
